import { render, staticRenderFns } from "./LocaleToolbarItem.vue?vue&type=template&id=8502d448&scoped=true&"
import script from "./LocaleToolbarItem.vue?vue&type=script&lang=ts&"
export * from "./LocaleToolbarItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8502d448",
  null
  
)

export default component.exports